import { render } from "./ModalTask_categories.vue?vue&type=template&id=f625f7ce"
import script from "./ModalTask_categories.vue?vue&type=script&lang=js"
export * from "./ModalTask_categories.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__